import { useLang } from "@/i18n";
import { PHONES, ADDRESS } from "@/lib/site";
import Logo from "@/components/Logo";

export default function Footer() {
    const { t } = useLang();
    return (
        <footer className="grain relative overflow-hidden bg-ink pb-24 pt-12 text-white/70 md:pb-12">
            <div className="relative mx-auto max-w-3xl px-4 sm:px-6">
                <Logo light />
                <p className="mt-3 text-sm">{t.footer.tag}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/50">{ADDRESS}</p>
                <p className="mt-1 text-sm" dir="ltr">
                    {PHONES.map((p) => p.label).join("  •  ")}
                </p>

                <div className="mt-8 border-t border-white/10 pt-5 text-xs leading-relaxed text-white/45">
                    <p>{t.footer.apkNote}</p>
                    <p className="mt-1.5">© {new Date().getFullYear()} Azmthullah Packers &amp; Movers. {t.footer.rights}</p>
                </div>
            </div>
        </footer>
    );
}
